module.exports = __webpack_public_path__ + "static/img/1.915a085.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/7/1.png
// module id = 279
// module chunks = 0